import React from 'react';
import { back, chevron_right, gear } from '../../Images/Icons';
import { useNavigate } from 'react-router-dom';
import { View } from '../../Components';
import faq_json from './Faq.json';

const FaqPage = () => {
    const navigation = useNavigate();

    const onGoback = () => {
        navigation(-1);
    }

    const onFaqCategory = (id) => () => {
        navigation(`/services/faq/detail/${id}`);
     }

    return (
        <div>
            <div class="mainHeader" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', }}>
                <div style={{ display: 'flex', margin: '0 20px' }}>
                    <div onClick={onGoback} style={{
                        display: 'flex', justifyContent: 'center', cursor: 'pointer',
                        alignItems: 'center', width: 32, height: 32, background: 'white', borderRadius: 16
                    }}>
                        <img src={back} alt="" style={{ width: 28, height: 28 }} />
                    </div>
                    <div style={{ fontSize: 18, fontWeight: 500, color: 'white', marginLeft: 12 }}>FAQ Category</div>
                </div>
            </div>
            <div className="page-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flex: 1, background: '#F2F5FA' }}>
                <div style={{ margin: 20 }}>
                    <div style={{ padding: 12, background: 'white', borderRadius: 12 }}>
                        {
                            faq_json.map((item, i) => (
                                <div key={`key-${i}`} onClick={onFaqCategory(item.id)} style={{ borderBottom: i === faq_json.length - 1 ? 'none' : 'solid 1px #ededed', padding: '8px 0', margin: '8px 8px', cursor: 'pointer' }}>
                                    <View justifyContent={"space-between"} alignItems={"center"}>
                                        <span style={{ fontSize: 14, fontWeight: 500, color: '#292929' }}>{item.category}</span>
                                        <img src={chevron_right} alt="" style={{ width: 28, height: 28 }} />
                                    </View>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FaqPage